import React from "react";
import { asyncNoop } from "../utils.js";
import { AvailableUsersQuery } from "./AvailableUsersProvider.generated.js";

type AvailableUsersContextType = {
  availableUsers: Extract<
    AvailableUsersQuery["availableUsers"],
    { __typename: "AvailableUsersResult" }
  >["availableUsers"];
  isLoading: boolean;
  refetch: () => Promise<unknown>;
};
export const AvailableUsersContext =
  React.createContext<AvailableUsersContextType>({
    availableUsers: [],
    isLoading: false,
    refetch: asyncNoop,
  });
